/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindByTypeQueryResponse, AgreementsControllerFindByTypePathParams, AgreementsControllerFindByType401, AgreementsControllerFindByType404 } from "../../models/agreementsController/AgreementsControllerFindByType";

function getAgreementsControllerFindByTypeUrl(type: AgreementsControllerFindByTypePathParams["type"]) {
  const res = { method: 'GET', url: `/api/v1/agreements/${type}` as const }  
  return res
}

/**
 * @summary Get active agreement by type
 * {@link /api/v1/agreements/:type}
 */
export async function agreementsControllerFindByType(type: AgreementsControllerFindByTypePathParams["type"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgreementsControllerFindByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindByType401 | AgreementsControllerFindByType404>, unknown>({ method : "GET", url : getAgreementsControllerFindByTypeUrl(type).url.toString(), ... requestConfig })  
  return res.data
}